import { default as doesTableSupportUndo } from './util/doesTableSupportUndo';
import { LazyAction, LazyModule } from 'owa-bundling';
import {
    addActionToUndoStack,
    clearLastUndoableAction,
    hasUndoableAction,
} from './actions/undoActions';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "UndoAction" */ './lazyIndex'));

export let lazyUndo = new LazyAction(lazyModule, m => m.undo);

export { addActionToUndoStack, clearLastUndoableAction, doesTableSupportUndo, hasUndoableAction };
